import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = articles.slice(3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-600 text-sm">持续更新中，敬请关注</p>
          </div>
          <Link
            to="/category/wenhua-neihan"
            className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <article key={article.id} className="group bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden">
              <Link to={`/article/${article.slug}`} className="block cursor-pointer">
                <div className="relative w-full h-44 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </Link>
              <div className="p-5">
                <Link
                  to={`/category/${article.category}`}
                  className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2 hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {article.categoryName}
                </Link>
                <Link to={`/article/${article.slug}`} className="block cursor-pointer">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                </Link>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}